/* eslint-disable @typescript-eslint/no-explicit-any */

import { create } from "zustand";

export interface ModalType {
  managementMandate?: boolean,
  deposit?: boolean,
  transfer?: boolean,
  withdraw?: boolean,
  kycRequired?: boolean,
  managementProfileType?: boolean,
  managementProfileSelect?: boolean,
  welcome?: boolean,
  startDca?: boolean,
  listCoin?: boolean,
  signContractSuccess?: boolean
  vigilance?: boolean,
  travelRule?: boolean,
  buyDvx?: boolean,
}

type ModalState = {
  modal: ModalType;
  setModal: (modal: ModalType) => void;
};

export const useModalStore = create<ModalState>((set) => ({
  modal: {
    managementMandate: false,
    deposit: false,
    transfer: false,
    withdraw: false,
    kycRequired: false,
    managementProfileType: false,
    managementProfileSelect: false,
    welcome: false,
    startDca: false,
    listCoin: false,
    signContractSuccess: false,
    vigilance: false,
    travelRule: false,
    buyDvx: false,
  },
  setModal: (modal: Partial<ModalType>) => set((state) => ({
    modal: { ...state.modal, ...modal }
  }))
}));
